import { string } from 'yup';

const passwordConfirm = string().test('passwords-match', "Passwords don't match", function (value) {
    return this.parent.password === value;
});

export { passwordConfirm };
